module.exports = __webpack_public_path__ + "static/media/button-position-after.b6f1610d.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/rostery/src/button-position-after.png
// module id = 638
// module chunks = 0